const HEADER_ID = 'tv-header';
const FOOTER_ID = 'tv-footer';

const OS_BLOCK_ACTIVE_CLASS = 'info-for-OSBlock__title-with-icon--active';
window.toggleOSBlockDetails = event => event.currentTarget.classList.toggle(OS_BLOCK_ACTIVE_CLASS);
window.closeOSBlockDetails = event => event.currentTarget.parentElement.previousElementSibling.classList.remove(OS_BLOCK_ACTIVE_CLASS);

/**
 * IE11 NodeList.forEach() polyfill
 */
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

const domReady = function () {

	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	const isAndroid = /android/i.test(userAgent) && /wv/i.test(userAgent);
	const isIos = /ipad|iphone/.test(userAgent) && /mediafirst/i.test(userAgent) || /iPad|iPhone/.test(userAgent);
	// Display header and footer if it's not an iPhone or iPad
	if (!isIos) {
		const header = document.getElementById(HEADER_ID);
		const footer = document.getElementById(FOOTER_ID);

		if (header) {
			header.style.display = 'block';
		}

		if (footer) {
			footer.style.display = 'block';
		}
	}

	const isAndroidDisabled =  isAndroid && window.disableAndroid;
	const isIosDisabled = isIos && window.disableIos;

	if (isAndroidDisabled || isIosDisabled) {
		if (isIosDisabled) {
			document.querySelectorAll('[data-ios-prevent-default=""]').forEach(element => {
				element.addEventListener('click', event => {
					event.preventDefault();
					return false;
				});
			});
		}
		document.querySelectorAll('a[data-instead-of-registration=""]').forEach(element => {
			element.classList.add('show-button');
		});
		const infoBox = document.querySelector('.info-for-OSBlock');
		if (infoBox && infoBox.style) infoBox.style.display = 'block';
	} else {
		document.querySelectorAll('a[data-registration-button=""]').forEach(element => {
			element.classList.add('show-button');
		});

		if (document.getElementById('header-login-button')) {
			document.getElementById('header-login-button').insertAdjacentHTML('afterend', '<a class="btn" href="/portal/regisztraciok">Regisztráció</a>');
		}
	}
	/**
	 * Galaxy Note10+on ugorjon egy kicsit feljebb az input, ha épp focusálunk benne
	 */
	const GALAXY_NOTE10PLUS_SIZE = {
		width: 412,
		height: 869
	};
	if (/android/i.test(userAgent) && GALAXY_NOTE10PLUS_SIZE.width == screen.width && GALAXY_NOTE10PLUS_SIZE.height == screen.height) {
		const htmlOrBody = document.querySelector('html') || document.querySelector('body');
		const inputElement = document.querySelector('input');
		const scrollTopPadding = 8;
		let scrollTopLast = 0;

		inputElement.addEventListener('focus', (el) => {
			scrollTopLast = htmlOrBody.scrollTop;
			const textareaTop = el.offsetTop;
			window.scrollBy({top: textareaTop - scrollTopPadding, left: 0, behavior: 'smooth'});
		});

		inputElement.addEventListener('blur', () => {
			htmlOrBody.scrollTo(0, scrollTopLast);
		});
	}

	window.goToLink = event => {
		if (/ipad|iphone/i.test(userAgent)) {
			event.preventDefault();
			return false;
		}
	};
};

document.addEventListener('DOMContentLoaded', domReady);




// WEBPACK FOOTER //
// ../source/build-entry/layouts/utils.js